import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { LanguageProvider } from "@/components/LanguageContext";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Partners from "./pages/Partners";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Software from "./pages/Software";
import Solutions from "./pages/Solutions";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <Router>
      <LanguageProvider>
        <div className="flex flex-col min-h-screen scroll-smooth antialiased bg-warm-white text-charcoal font-sans">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/services" element={<Services />} />
              <Route path="/software" element={<Software />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
